<template>
  <v-autocomplete @input="
    (event) => {
      $emit('input', event);
    }
  " v-model="selectedMember" :items="members" :label="label" item-text="text" item-value="value" clearable outlined
    :background-color="backgroundColor" dense :hide-details="hideDetails ? hideDetails : false"></v-autocomplete>
</template>

<script>
import Api from "@/services/Api";
export default {
  data() {
    return {
      members: [],
      selectedMember: null,
    };
  },
  props: ["value", "label", "items", "admins", "skipUser", "hideDetails", "backgroundColor"],
  created() {
    if (this.items) {
      for (const m of this.items) {
        if (!this.skipUser || (this.skipUser && m._id != this.skipUser))
          this.members.push({ value: m._id, text: m.displayName ? m.displayName : m.name });
      }
      this.assignValue();
    } else {
      Api()
        .get("admins/academy/" + this.$store.state.selectedAcademy + "/members?add_admins=true")
        .then((response) => {
          const data = response.data;
          if (data) {
            for (const m of data.approved) {
              let text = m.displayName;
              if (!text)
                text = m.name;
              if (!text)
                text = m.fName + " " + m.lName;
              if (!this.skipUser || (this.skipUser && m._id != this.skipUser))
                this.members.push({
                  value: m._id,
                  text: text,
                });
              this.assignValue();
            }
          }
        });
    }
  },
  watch: {
    selectedMember: {
      immediate: false,
      handler: function (newValue) {
        this.$emit("user_picked", newValue);
      },
    },
  },
  methods: {
    assignValue() {
      if (this.value) {
        this.selectedMember = this.value;
      }
    }
  },
};
</script>

<style scoped></style>
